export const solutions = [
  {
    icon: 'point.png',
    title: '포인트or스탬프 적립',
    description: '키오스크에서 바로 \n 적립이 가능한 서비스 입니다.',
  },
  {
    icon: 'mobile.png',
    title: '모바일 오더',
    description: '스마트폰으로 미리 \n 주문을 할 수 있는 서비스 입니다.',
  },
  {
    icon: 'delivery.png',
    title: '배달 매출 연동',
    description: '매장 관리 시스템에 \n 배달 매출이 연동됩니다.',
  },
  {
    icon: 'pos.png',
    title: '포스 연동',
    description: '키오스크와 포스가 연동되어\n 주문내역 관리가 편합니다.',
  },
  {
    icon: 'card.png',
    title: '선불카드(구독권) 관리',
    description: '선불카드를 발행하여, \n단골 손님을 늘릴 수 있습니다.',
  },
  {
    icon: 'label.png',
    title: '라벨 프린터 연동',
    description: '고객님께 상품 정보를\n라벨프린터로 전달 가능합니다.',
  },
  {
    icon: 'stock.png',
    title: '재고 연동',
    description: '점주님 매장의 재고 품목을\n확인 가능합니다.',
  },
];

export const connects = [
  {
    img: 'kiosk',
    title: '키오스크',
    desc: '주문이 가능한 무인결제 프로그램입니다.',
  },
  {
    img: 'monitor',
    title: '모니터 호출',
    desc: '완료된 주문 번호를 모니터로 호출합니다.',
  },
  {
    img: 'bell',
    title: '진동벨 호출',
    desc: '완료된 주문을 진동벨로 호출합니다.',
  },
  {
    img: 'talk',
    title: '알림톡 호출',
    desc: '카카오톡으로 호출이 가능합니다.',
  },
  {
    img: 'pos',
    title: '포스',
    desc: '키오스크와 연동되는 포스 프로그램입니다.',
  },
  {
    img: 'management',
    title: '매장관리',
    desc: '웹과 모바일로 매장을 관리합니다.',
  },
];
